export const images = {
  imgBotella: require("@/assets/img/campaign/cb.png"),
  "00/edicion": require("@/assets/img/campaign/00/edicion.png"),
  "00/galardon": require("@/assets/img/campaign/00/galardon.png"),
  "00/periodo": require("@/assets/img/campaign/00/periodo.png"),
  "00/producto": require("@/assets/img/campaign/00/producto.png"),

  "01/edicion": require("@/assets/img/campaign/01/edicion.png"),
  "01/galardon": require("@/assets/img/campaign/01/galardon.png"),
  "01/periodo": require("@/assets/img/campaign/01/periodo.png"),
  "01/producto": require("@/assets/img/campaign/01/producto.png"),

  "02/edicion": require("@/assets/img/campaign/02/edicion.png"),
  "02/galardon": require("@/assets/img/campaign/02/galardon.png"),
  "02/periodo": require("@/assets/img/campaign/02/periodo.png"),
  "02/producto": require("@/assets/img/campaign/02/producto.png"),

  "03/edicion": require("@/assets/img/campaign/03/edicion.png"),
  "03/galardon": require("@/assets/img/campaign/03/galardon.png"),
  "03/periodo": require("@/assets/img/campaign/03/periodo.png"),
  "03/producto": require("@/assets/img/campaign/03/producto.png"),

  "0_dots": require("@/assets/img/campaign/0_dots.svg"),
  "0_pintura": require("@/assets/img/campaign/0_pintura.svg"),
};

export const videos = {
  videoUrl: require("@/assets/videos/campaingNew_video.mp4"),
  webmUrl: require("@/assets/videos/campaingNew_web.mp4"),
  poster: require("@/assets/img/home/home_poster.jpg"),
};

export const videosInterior = [
  {
    videoUrl: require("@/assets/videos/campaingNew_web.mp4"),
    videoUrlWeb: require("@/assets/videos/campaingNew_video.mp4"),
    poster: require("@/assets/videos/VIDEO08.png"),
    titulo: "Agosto2020",
  },
  //{
  //videoUrl: require("@/assets/videos/1.mp4"),
  //poster: require("@/assets/videos/VIDEO01.png"),
  //titulo: "Hoy el carbón si nos prende a la primera.",
  //},
  /*{
    videoUrl: require("@/assets/videos/6.mp4"),
    poster: require("@/assets/videos/VIDEO02.png"),
    titulo: "Las quesadillas, ¿con queso o sin queso?",
  },
  {
    videoUrl: require("@/assets/videos/2.mp4"),
    poster: require("@/assets/videos/VIDEO03.png"),
    titulo: "La carnita puede ir en su jugo y también asada.",
  },
  {
    videoUrl: require("@/assets/videos/3.mp4"),
    poster: require("@/assets/videos/VIDEO04.png"),
    titulo: "¿La cheve se enfría en el refri o la hielera?",
  },
  {
    videoUrl: require("@/assets/videos/4.mp4"),
    poster: require("@/assets/videos/VIDEO05.png"),
    titulo: "Esta noche se baila banda.",
  },
  {
    videoUrl: require("@/assets/videos/5.mp4"),
    poster: require("@/assets/videos/VIDEO06.png"),
    titulo: "El norteño, el pasito duranguense y la banda, ¿es lo mismo?",
  },*/
];
